import { CALL_API } from 'middleware/api';
import * as types from './types/websiteLogo';
export const getWebsiteLogo = (domain) => {
    const search = new URLSearchParams({ domain });
    return {
        [CALL_API]: {
            endpoint: `/website-logo?${search}`,
            method: 'GET',
            types: [
                types.GET_WEBSITE_LOGO_REQUEST,
                types.GET_WEBSITE_LOGO_SUCCESS,
                types.GET_WEBSITE_LOGO_FAILURE,
            ],
        },
    };
};
